export enum Role {
  INVESTOR,
  LOAN_APPLICANT,
}
